import { render } from "./BuscarItensRecebimentoMercadorias.vue?vue&type=template&id=330a0374&scoped=true&ts=true"
import script from "./BuscarItensRecebimentoMercadorias.vue?vue&type=script&lang=ts"
export * from "./BuscarItensRecebimentoMercadorias.vue?vue&type=script&lang=ts"

import "./BuscarItensRecebimentoMercadorias.vue?vue&type=style&index=0&id=330a0374&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330a0374"]])

export default __exports__